import type { ObjectDirective } from "vue";

export type Position = { x?: number; y?: number };

// Only runtime measurements live here. All layout declarations are in SCSS.
export const vPosition: ObjectDirective<HTMLElement, Position> = {
  mounted: updatePosition,
  updated: updatePosition,
};
function updatePosition(element: HTMLElement, { value }: { value: Position }) {
  for (const axis of ["x", "y"] as const) {
    const coordinate = value?.[axis];
    if (Number.isFinite(coordinate))
      element.style.setProperty(`--position-${axis}`, `${coordinate}px`);
    else element.style.removeProperty(`--position-${axis}`);
  }
}

export const vSize: ObjectDirective<HTMLElement, number> = {
  mounted: updateSize,
  updated: updateSize,
};
function updateSize(element: HTMLElement, { value }: { value: number }) {
  if (Number.isFinite(value) && value > 0)
    element.style.setProperty("--element-size", `${value}px`);
  else element.style.removeProperty("--element-size");
}
